import type { KeyView } from '../lib/viewPreference'

interface ViewToggleProps {
  view: KeyView
  onChange: (view: KeyView) => void
}

const base = 'p-2 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-accent'
const active = 'bg-gray-100 text-gray-900'
const idle = 'bg-white text-gray-400 hover:text-gray-600'

export default function ViewToggle({ view, onChange }: ViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-gray-200 overflow-hidden shadow-subtle">
      <button
        type="button"
        aria-label="Card view"
        aria-pressed={view === 'cards'}
        title="Card view"
        onClick={() => onChange('cards')}
        className={`${base} ${view === 'cards' ? active : idle}`}
      >
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z" />
        </svg>
      </button>
      <button
        type="button"
        aria-label="List view"
        aria-pressed={view === 'table'}
        title="List view"
        onClick={() => onChange('table')}
        className={`${base} border-l border-gray-200 ${view === 'table' ? active : idle}`}
      >
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>
    </div>
  )
}
